// extracted by mini-css-extract-plugin
export default {"description":"Video_description__hztgd","videoContainer":"Video_videoContainer__5WMz3","iconProject":"Video_iconProject__lRDBE","bottom":"Video_bottom__xnqfd"};